import Link from "next/link";
import SectionHeader from "@/components/SectionHeader";

export default function OccasionsList({ occasions }) {
  const cardHover =
    "rounded-3xl bg-white p-6 shadow-[0_12px_40px_-28px_rgba(15,23,42,0.45)] ring-1 ring-black/5 transition hover:-translate-y-0.5 hover:shadow-[0_18px_55px_-34px_rgba(15,23,42,0.55)] will-change-transform";

  const defaultOccasions = occasions || [
    {
      title: "Fotobox mieten Hochzeit",
      description: "Preise & Optionen",
      href: "/fotobox-mieten-hochzeit",
    },
    {
      title: "Fotobox mieten Geburtstag",
      description: "Pakete im Überblick",
      href: "/fotobox-mieten-geburtstag",
    },
    {
      title: "Fotobox mieten Firmenfeier",
      description: "Business-Lösungen",
      href: "/fotobox-mieten-firmenfeier",
    },
    {
      title: "Fotobox mieten Weihnachtsfeier",
      description: "Große Events planen",
      href: "/fotobox-mieten-weihnachtsfeier",
    },
  ];

  return (
    <SectionHeader
      title="Fotobox mieten nach Anlass"
      subtitle="Unterschiede, Preise und Optionen im direkten Vergleich – je nach Eventtyp."
    >
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {defaultOccasions.map((item) => (
          <Link key={item.title} href={item.href} className={cardHover}>
            <h3 className="text-lg font-semibold tracking-tight text-slate-900">
              {item.title}{" "}
              <p className="mt-2 font-normal text-sm text-slate-600">
                – {item.description}
              </p>
            </h3>

            <p className="mt-5 text-sm font-semibold text-[#FF5744]">
              Jetzt vergleichen →
            </p>
          </Link>
        ))}
      </div>
    </SectionHeader>
  );
}
